export default __webpack_public_path__ + "static/media/payroll.9180f7ab.svg";